import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function Financing() {
  const steps = [{
    number: '1',
    title: 'Apply in 2 Minutes',
    desc: 'Quick digital application'
  }, {
    number: '2',
    title: 'Instant On-Site Approval',
    desc: 'No long waiting periods'
  }, {
    number: '3',
    title: '$0 Down Payment Options',
    desc: 'Start treatment today'
  }];
  return <section className="py-20 bg-white border-y border-slate-100" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0F2C59] mb-4" data-id="element-56">
            AFFORDABLE FLEXIBLE FINANCING
          </h2>
          <p className="text-xl text-[#4F709C]" data-id="element-57">
            Get your dream smile today with one of the best financing options
            around—Up to 3 Years (36 Months) Flex-Pay.
          </p>
        </div>

        <div className="relative" data-id="element-58">
          {/* Timeline Line */}
          <div className="hidden md:block absolute top-10 left-0 right-0 h-0.5 bg-slate-100 z-0" data-id="element-59" />

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-60">
            {steps.map((step, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-61">
                <div className="w-20 h-20 bg-white border-4 border-[#0D9488] rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-62">
                  <span className="text-2xl font-bold text-[#0F2C59]" data-id="element-63">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#0F2C59] mb-2" data-id="element-64">
                  {step.title}
                </h3>
                <p className="text-slate-500" data-id="element-65">{step.desc}</p>
              </div>)}
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-66">
          <button className="bg-[#0D9488] hover:bg-[#0F766E] text-white px-10 py-4 rounded-lg font-bold text-lg flex items-center gap-2 mx-auto transition-all" data-id="element-67">
            Apply for Financing Now
            <ArrowRight size={20} data-id="element-68" />
          </button>
        </div>
      </div>
    </section>;
}